<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.ivu-mr,
.ivu-mr-16 {
  margin-right: 16px !important;
}
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}
.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}
.flexs {
  display: flex !important;
  width: 20%;
}
//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-place">

      <div class="flex items-center justify-between ivu-mt">
        <div class="flex items-center">
          <p>场所类型：</p>
          <el-row>
             <el-button type="info" :class="{active:search_data.type==''?true:false}" plain @click="placetype(1)" v-model="search_data.type">全部</el-button>
            <el-button type="info" plain :class="{active:search_data.type==item.id?true:false}" v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type">{{item.name}}</el-button>
          </el-row>
          <el-row style="text-align:right; flex:1;">
          <l-auth-button class="ivu-mr" type="info" auth="place_import_btn" @click="import_visible=true" :loading="import_loading"> 导入 </l-auth-button>
          </el-row>
        </div>
      </div>
      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所名称</p>
          <el-input placeholder="请输入场所名称" v-model="search_data.name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
    
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">负责人</p>
          <el-input placeholder="请输入负责人" v-model="search_data.charge" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">日期</p>
          <div class="l-show-more-search" style="width: 76%;">
            <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
            </el-date-picker>
          </div>
        </div> -->

      </div>
    </div>
    <div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <div class="">
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;" @click="resetFixedCheck">重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">
                {{item.label}}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>

      <div style="float: right;" @click="search_visible = true">
        <span>
          <i class="el-icon-search"></i>
          高級搜索
        </span>
      </div>

    </div>
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label" show-overflow-tooltip>
        <template v-slot="{ row }">
              {{ row[item.prop] }}
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="resource_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="resource_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
    <!--高级搜索-->
    <el-drawer title="更多搜索" class="l-search-drawer" :modal="false" :visible.sync="search_visible" size="400px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
      <div class="l-search-drawer-body">
        <el-form label-width="80px" ref="search_form" :model="search_data">
          <el-form-item label="场所名称" prop="name">
            <el-input v-model="search_data.name" placeholder="请输入场所名称"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="charge">
            <el-input v-model="search_data.charge" placeholder="请输入负责人"></el-input>
          </el-form-item>
          <el-form-item label="时间筛选" prop="value2">
            <div class="l-show-more-search" style="width: 76%;">
              <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="l-search-drawer-footer">
        <el-button type="normal" @click="onReset">重置</el-button>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </div>
    </el-drawer>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="场所信息"  width="1600px">
      <l-place-info :visible.sync="info_visible" :id="info_id" is-info />
    </l-dialog>

 <!--导入-->
    <l-dialog :visible.sync="import_visible" title="导入" width="800px">
      <l-place-import_s @on-success="onImportSuccess" :visible.sync="import_visible" />
    </l-dialog>


  </el-card>
</template>
<script>
// import { dateToStr,time_pick2 } from "@/utils/Fuc";
import Info from "./Info";
import Vue from "vue";
import Import from "./Import_s.vue";
export default {
  components: {
    [Info.name]: Info,
    [Import.name]: Import
  },
  data() {
    return {
      value1: '',
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      change_state_loading: [],

      info_visible: false, //是否显示编辑
      edit_visible: false, //是否显示编辑
       import_visible:false,//是否显示导入
      edit_id: 0,
      info_id: 0,
      place_type_list: [],
    
      //搜索
      search_visible: false,
      search_data: {
        name: "",
        charge: "",
        network: "",
        start_time: '',
        end_time: '',
        type: '',
      },
      rel_search_data: {},
      show_more_search: false,
      value2: '',
         import_loading: false,
      //默认
      re_fixed_list: ["index","type_name", "community_name", "place_sn", "name", "address", "network","charge", "iphone"],
      fixed_list: ["index", "type_name","community_name", "place_sn", "name", "address" ,"network","charge", "iphone"],
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          prop: "index",
          label: "序号",
          fixed: true,
          minWidth: "60",
        },
        {
          prop: "type_name",
          label: "场所类型",
          fixed: true,
          minWidth: "150",
        },
        {
          prop: "community_name",
          label: "所属社区",
          fixed: true,
          minWidth: "150",
        },
        // {
        //   prop: "place_sn",
        //   label: "场所编码",
        //   fixed: true,
        //   Width: "120",
        // },
        {
          prop: "name",
          label: "场所名称",
          fixed: true,
          Width: "120",
        },
        {
          prop: "address",
          label: "场所地址",
          fixed: true,
          Width: "120",
        },
        {
          prop: "network",
          label: "所属网络",
          fixed: true,
          minWidth: "150",
        },
        {
          prop: "charge",
          label: "场所负责人",
          fixed: true,
          minWidth: "150",
        },
        {
          prop: "iphone",
          label: "负责人电话",
          fixed: true,
          minWidth: "180",
        },
      ];

      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {

    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
    //通过类型筛选
    placetype(id) {
      this.search_data.type = id;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("account_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取搜索信息 

    getSearchData() {
      this.loading = true;
      this.$_invoke("place_getSearchData", {
      })
        .then((ret) => {
          this.place_type_list = ret.place_type_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`resource_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },
    //默认时间
    // onfocus() {
    //   if (this.value2 == "" || !this.value2) {
    //     this.value2 = time_pick2();
    //   }
    // },
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },

      //显示导入
    onImportSuccess() {
      this.import_visible = false;
      this.getList();
    },
  },
};
</script>
